export default __webpack_public_path__ + "static/media/IMG_2587.ffecce16.jpeg";